module.exports = __webpack_public_path__ + "static/02-97b325195f6fd2800c54e56f01e5b9d8.jpg";